import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    warningContainer: {
      backgroundColor: STYLE.COLOR.WARNING_NOTE,
      borderRadius: '4px',
      padding: '6px 8px',
      display: 'flex',
      flexDirection: 'row',
    },
    warningText: {
      color: STYLE.COLOR.TEXT1,
      fontSize: '12px',
      fontWeight: 500,
      lineHeight: '16px',
      alignSelf: 'center',
    },
    warningIcon: {
      minWidth: '20px',
      marginRight: '8px',
    },
  }),
);
